import { BkRoutes } from 'bkng';

import { participants } from './participants/participants';

export const campaign: BkRoutes = [
    participants,
];
